<template>
  <div>
    <div class="footerBox" v-if="type == 1">
      <div class="w">
        <div class="footerLeft">
          <img v-if="showType == 1" src="@/assets/logo_就业育人.png" alt="">
          <img v-else src="@/assets/logo-footer.png" alt="">
          <!-- <img :src="showType == 1 ? '@/assets/logo_就业育人.png' : '@/assets/logo-footer.png'" alt=""> -->
          <div >
            <div v-if="showAbout == 1" style="height:16px; margin-bottom: 12px">
              <span class="about-link" @click="toAbout">关于毕业申</span>
            </div>
            <a v-if="showType == 1" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20024996号-3<span class="lines"></span></a>
            <a v-if="showType == 2" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20024996号-1<span class="lines"></span></a>
            <a v-if="showType == 3" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备17007916号-3<span class="lines"></span></a>
          </div>
        </div>
        <div class="footerRight">
          <dl>
            <dt>公司地址</dt>
            <dd>上海：上海人才大厦19楼（静安区梅园路77号）</dd>
            <dd>北京：清华大学科技园B座清华X-Lab（海淀区中关村东路1号）</dd>
          </dl>
          <dl>
            <dt>联系方式</dt>
            <dd>021-66696957</dd>
            <dd>info@applyoffer.com</dd>
          </dl>
        </div>
      </div>
    </div>
    <div v-if="type != 1" class="change-foot">
      <!-- 除主站外 -->
      <div class="footer-content">
        <div v-if="!isShow" class="apply">技术支持</div>
        <img v-if="!isShow" class="hov" :src="showType == 3 ?   require('@/assets/grey-bys.png'): require('@/assets/grey-jyyr.png')" alt="" width="103px" height="20px" style="margin-right: 58px;" @click="toMainSate">
          <a v-if="showType == 1" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20024996号-3<span class="lines"></span></a>
          <a v-if="showType == 2" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20024996号-1<span class="lines"></span></a>
          <a v-if="showType == 3" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备17007916号-3<span class="lines"></span></a>
      </div>
    </div>
  </div>
</template>

<script>
import {getsiteInfo} from '@/api/indexPage'
  export default {
    props: {
        sitedata: {
          type: Object,
          default: ''
        }
      },
    data() {
      return {
        showType:0,//1.jiuyeyuren.com 2.biyeshen.cn 3.applyoffer.com
        type:'',
        showAbout: '',
        isShow: false
      }
    },
    created() {
      // type 类型：1：主站；2：学校；3：渠道
      this.type = this.sitedata.type
      // 是否显示关于毕业申 入口 0否  1是
      this.showAbout = this.sitedata.show_about
      if( window.location.origin.split('//')[1].indexOf('jiuyeyuren.com') > -1){
        this.showType = 1

      }else if(window.location.origin.split('//')[1].indexOf('biyeshen.cn') > -1){
        this.showType = 2
      }else if(window.location.origin.split('//')[1].indexOf('applyoffer.com') > -1){
        this.showType = 3
      }
      getsiteInfo().then((res)=>{
        if(res.apiStatus) {
          this.isShow = res.is_hide_logo == 1 ? true : false
        }
      })
    },
    methods:{
      toAbout(){
        this.$router.push({path:'/about'})
      },
      toMainSate(){
        console.log('toMainSate',this.showType)
        if(this.showType == 1){
          //就业育人主站
          window.open('https://jiuyeyuren.com')
        }else if(this.showType == 3){
          // 毕业申主站
          window.open('https://biyeshen.cn')
        }
      }
    }
  }
</script>

<style scoped lang="less">
.hov{
  cursor:pointer;
}
  .footerBox {
    width: 100%;
    height: 219px;
    padding: 40px 0;
    box-sizing: border-box;
    background-color: #F6F7F9;
    border-top: 1px solid  #EDEFF3;
    .w {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      .footerLeft {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .about-link {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #808695;
          line-height: 16px;
          cursor: pointer;
          &:hover {
            color: #356FFA;
          }
        }
        img {
          width: 150px;
          height: 36px;
        }
        a {
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: #808695;
          line-height: 16px;
          position: relative;
          .lines {
            display: inline-block;
            width: 1060px;
            border-bottom: 1px solid #EDEFF3;
            position: absolute;
            top: 50%;
            left: 135px;
            transform: translateY(-50%);
            z-index: 2;
          }
        }

      }
      .footerRight {
        display: flex;
        font-size: 14px;
        dl {
          margin-right: 80px;
          dt {
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: #515A6E;
            line-height: 19px;
            margin-bottom: 24px;
          }
          dd {
            font-family: MicrosoftYaHei;
            color: #808695;
            line-height: 14px;
            margin-bottom: 12px;
          }
          dd:last-child {
            margin-bottom: 0;
          }
        }
        dl:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .change-foot{
    width: 100%;
    height: 108px;
    background: #F6F7F9;
    .footer-content{
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      // justify-content: center;
      align-items: center;
      .apply{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #808695;
        margin-right: 12px;
      }
      a {
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: #808695;
          line-height: 16px;
          position: relative;
          .lines {
            display: inline-block;
            width: 854px;
            border-bottom: 1px solid #EDEFF3;
            position: absolute;
            top: 50%;
            left: 135px;
            transform: translateY(-50%);
            z-index: 2;
          }
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/newFooter.vue